import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: React.CSSProperties;
}

const MapLayers = (props: Props): ReactElement => {
  const { width, height, style } = props;

  return (
    <svg
      height={height}
      width={width}
      fill="currentColor"
      viewBox="0 0 24 24"
      x="0px"
      y="0px"
      style={style}
    >
      <path d="M11.274 4.198c.439-.26.986-.264 1.428-.013l.03.018 6.598 3.966c.66.397.868 1.243.463 1.89-.11.175-.258.324-.433.435l-.035.022-.277.164.282.17c.651.391.862 1.219.48 1.862l-.017.029c-.11.175-.258.323-.433.434l-.035.022-.277.164.282.17c.651.391.862 1.22.48 1.863l-.017.028c-.11.175-.258.323-.433.435l-.035.021-6.596 3.922c-.44.262-.99.266-1.434.013l-.031-.018-6.597-3.989c-.66-.398-.865-1.246-.458-1.892.11-.174.258-.322.434-.433l.036-.022.273-.162-.285-.172c-.66-.399-.865-1.246-.458-1.892.11-.174.258-.323.434-.434l.036-.021.273-.162-.285-.172c-.65-.393-.859-1.221-.475-1.864l.017-.028c.11-.175.258-.323.434-.434l.036-.021 6.595-3.9zm-5.171 9.795l-.803.475c-.022.013-.041.03-.056.05l-.011.015c-.055.088-.032.201.052.261l.013.01 6.598 3.988c.059.036.132.039.194.01l.015-.009 6.596-3.922c.027-.016.05-.039.066-.065.055-.088.031-.202-.052-.262l-.014-.009-.809-.486-5.163 3.07c-.44.262-.99.266-1.434.013l-.031-.018-5.161-3.12zm0-2.68l-.803.474c-.022.013-.041.03-.056.05l-.011.015c-.055.088-.032.201.052.261l.013.01 6.598 3.988c.059.036.132.039.194.009l.015-.008L18.7 12.19c.027-.017.05-.039.066-.066.055-.087.031-.2-.052-.26l-.014-.01-.809-.486-5.163 3.07c-.44.262-.99.266-1.434.013l-.031-.018-5.161-3.12zm6.001-6.105c-.059-.036-.132-.039-.193-.01l-.015.009L5.3 9.106c-.027.016-.05.038-.067.065-.055.087-.032.201.052.261l.013.01 6.598 3.988c.059.036.132.039.194.009l.015-.008L18.7 9.508c.027-.016.05-.038.066-.065.055-.088.031-.201-.052-.26l-.014-.01-6.597-3.965z" />
    </svg>
  );
};

MapLayers.defaultProps = {
  width: '100%',
  height: '100%',
  style: {
    fill: 'currentColor',
  },
};

export default MapLayers;
